/**
 * Tiny "one audio at a time" bus: whichever player starts claims the speakers and every
 * other player (featured list, hover preview, release pop-up) pauses itself.
 */
type Listener = (owner: string) => void;
const listeners = new Set<Listener>();

export const audioBus = {
  claim(owner: string) {
    listeners.forEach((l) => l(owner));
  },
  on(l: Listener) {
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  },
};
